import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(tagAnatomy.keys);

const baseStyle = definePartsStyle({
    container: {
        fontWeight: 'medium',
        borderRadius: 'full',
        textTransform: 'capitalize'
    }
});

const variants = {
    status: definePartsStyle({
        container: {
            fontWeight: 'medium',
            borderRadius: 'full',
            textTransform: 'capitalize'
        }
    })
};

const sizes = {
    sm: definePartsStyle({
        container: {
            px: 1.5,
            py: 0.5,
            fontSize: 'sm'
        }
    }),
    md: definePartsStyle({
        container: {
            px: 2,
            py: 1,
            fontSize: 'md'
        }
    })
};

export const tagTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes
});
